import { ComponentSlotStylesPrepared, ICSSInJSStyle } from '@fluentui/styles';
import { DatepickerVariables } from './datepickerVariables';
import { DatepickerCalendarGridRowStylesProps } from '../../../../components/Datepicker/DatepickerCalendarGridRow';

export const datepickerCalendarGridRowStyles: ComponentSlotStylesPrepared<
  DatepickerCalendarGridRowStylesProps,
  DatepickerVariables
> = {
  root: (): ICSSInJSStyle => ({}),
};
